import React, { useEffect, useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import changeConfigAction from '../store/actions/config';
import changeViewAction from '../store/actions/views';
import changeLoadingAction from '../store/actions/loadingAction';
import appReadyAction from '../store/actions/appReadyAction';

import Theme from '@gameday/components/Theme/Theme';
import FONTS from '@mlb/react-patterns/v4/style/fonts';
import { getAppState } from '../store/selectors/appSelector';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import views from '../store/reducers/views';
import loading from '../store/reducers/loading';
import loggedIn from '../store/reducers/loggedIn';
import userinfo from '../store/reducers/userinfo';
import lockview from '../store/reducers/lockview';
import connectionError from '../store/reducers/connectionError';
import datasources from '../store/datasources';
import GamedayScaffoldContainer from './GamedayScaffoldContainer';
import configReducer from '../store/reducers/config';
import MessageService from 'message-service/message-service';
import DataEvents from '@gameday/core/events/DataEvents';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

const { UPDATE_GAMEDAY_URL } = DataEvents;

// register our datasources + reducers for the app
initContainerData.register({
    reducers: { views, loading, loggedIn, userinfo, config: configReducer, lockview, connectionError },
    datasources
});

const actions = (dispatch) => ({
    handleViewChange: (type) => {
        dispatch(changeViewAction(type));
    },
    handleConfigChange: (type) => {
        dispatch(changeConfigAction(type));
    },
    handleLoadingChange: (isLoading) => {
        dispatch(changeLoadingAction(isLoading));
    }
});

const fetchData = () => {
    return appReadyAction();
};

const theme = {
    fonts: {
        family: {
            primary: FONTS.primaryFont
        }
    }
};

const GamedayAppContainer = (props) => {
    const dispatch = useDispatch();
    const appState = useSelector(getAppState);
    const componentMap = props?.componentMap || props?.componentDataEngine?.opts?.componentMap || {};
    const appConfig = props?.componentDataEngine?.opts?.appConfig || {};
    useEffect(() => {
        const { views } = appState;
        const { handleViewChange, handleConfigChange } = actions(dispatch);

        handleViewChange(views);
        handleConfigChange(appConfig);

        MessageService.on(UPDATE_GAMEDAY_URL, (opts) => {
            handleViewChange(opts?.data);
        });
    }, []);
    const boundActions = useMemo(() => {
        return actions(dispatch);
    }, [dispatch]);

    useEffect(() => {
        const { handleViewChange, handleConfigChange } = boundActions;
        handleConfigChange(appConfig);
    }, [boundActions]);

    const { config: { enableDarkMode, themeMode } } = appState;
    return (
        <ErrorBoundaryWrapper componentName='GamedayAppContainer'>
            <Theme theme={ theme } enableDarkMode={enableDarkMode} themeMode={themeMode}>
                <GamedayScaffoldContainer componentMap={componentMap} { ...appState } { ...boundActions } />
            </Theme>
        </ErrorBoundaryWrapper>
    );
};

GamedayAppContainer.propTypes = {
    componentDataEngine: PropTypes.object,
    componentMap: PropTypes.object
};

export default memo(GamedayAppContainer);
export { fetchData };
